import { writable, derived } from 'svelte/store';
import { termsStore } from './termsStore';

// Store for spec content
export const specStore = writable({
    content: '',
    protectedRanges: [], // Ranges that shouldn't be modified by auto-generation
    isRegenerating: false // Flag to indicate if content change is from regeneration
});

// Store for claims content
export const claimsStore = writable({
    content: '# This is an in-line comment. It won\'t appear in the exported Word document.\n1. ',
    terms: new Set(),
    antecedentErrors: [],
});

// Store for cursor position and selection
export const cursorStore = writable({
    position: 0,
    selection: null,
    activeEditor: null, // 'spec' or 'claims'
});

// Derived store for term locations in claims
export const termLocationsStore = derived(
    [claimsStore, termsStore],
    ([_$claims, _$terms]) => {
        const locations = {};
        // This will be populated by the backend service
        // Format: { termId: [{ start, end, text }] }
        return locations;
    }
);

// Store for editor state
export const editorStateStore = writable({
    isAnalyzing: false,
    isDirty: false,
    lastSaved: null,
    activeCollaborators: new Set(),
    abstractWordCount: 0,
    abstractExceedsLimit: false,
    duplicateSections: [], // Array of { sectionType, displayName, count }
});

// Re-export termsStore for backward compatibility
export { termsStore };
